import { MDBBtn } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { CustomModal } from "../CustomModal";

export interface DeleteConfirmModalProps {
    open: boolean;
    title: string;
    message: string;
    confirmText?: string;
    onConfirm: () => void;
    onCancel: () => void;

}
export const DeleteConfirmModal = ({open, title, message, confirmText, onConfirm, onCancel}: DeleteConfirmModalProps) => {
    const { t } = useTranslation();

    return (
        <CustomModal
            open={open}
            title={title}
            onClose={onCancel}
            footer={(
                <>
                    <MDBBtn color="secondary" onClick={onCancel}>{t('cancel')}</MDBBtn>
                    <MDBBtn color="danger" onClick={onConfirm}>{confirmText || t('delete')}</MDBBtn>
                </>
            )}
        >
            <span>{message}</span>
        </CustomModal>
    )
}